
<template>
    <div>
        <vs-table>
            <template #thead>
            <vs-tr>
                <vs-th style="width: 15%;">
                    Matrícula
                </vs-th>
                <vs-th style="width: 30%;">
                    Alumno
                </vs-th>
                <vs-th style="width: 15%;">
                    Grado
                </vs-th>
                <vs-th style="width: 30%;">
                    Estatus
                </vs-th>
                <vs-th>
                    Acciones
                </vs-th>
            </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in users"
                :data="tr"
            >
                <vs-td>
                    <p>{{ tr.persona.matricula }}</p>
                </vs-td>
                <vs-td>
                    <p>{{ tr.persona.apellido_paterno}} {{tr.persona.apellido_materno}} {{tr.persona.nombres}}</p>
                </vs-td>
                <vs-td>
                    <p>{{ tr.persona.grado}}</p>
                </vs-td>
                <vs-td>
                    <md-chip :class="'mini-chip col-' + estatusColor[tr.status.status]['color']" ><strong> {{ tr.status.status }} </strong></md-chip>
                </vs-td>
                <vs-td>
                    <div class="d-flex">
                        <vs-tooltip>
                            <vs-button
                                icon
                                color="success"
                                flat
                                class="mr-1"
                                :href="'panel/alumno/'+window.btoa(tr.persona.id)+'/institucion/'+window.btoa(tr.persona.institucion_id)"
                                blank
                            >
                                <i style="font-size: 15px;" class="far fa-address-card"></i>
                            </vs-button>
                            <template #tooltip>
                                Ir a perfil
                            </template>
                        </vs-tooltip> 
                        <vs-tooltip>
                            <vs-button
                                icon
                                flat
                                class="mr-1"
                                @click="activeEditar = !activeEditar; selectRow = tr"
                            >
                                <i style="font-size: 15px;" class="far fa-edit"></i>
                            </vs-button>
                            <template #tooltip>
                                Editar información
                            </template>
                        </vs-tooltip> 
                    </div>
                </vs-td>
            </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>
        </vs-table>
        <editar v-model="activeEditar" :row="selectRow" :token="token" @refreshTable="getRefresh"></editar>
    </div>
</template>

<script>
import editar from './modal/editar.vue'
export default {
    props: [
        'users',
        'token'
    ],
    data:() => ({
        estatusColor: {
            'Prospecto': {
                'color': 'purple'
            },
            'Interesado': {
                'color': 'brown'
            },
            'Aplicante': {
                'color': 'blue'
            },
            'Admitido': {
                'color': 'green'
            },
            'Inscrito económico': {
                'color': 'blue'
            },
            'Congelado': {
                'color': 'pink'
            },
            'Descartado': {
                'color': 'pink'
            },
            'Inscrito académico': {
                'color': 'yellow'
            },
            'Acreditado en ciclo escolar': {
                'color': 'green'
            },
            'No acreditado en ciclo escolar': {
                'color': 'pink'
            },
            'Baja definitiva voluntaria': {
                'color': 'gray'
            },
            'Baja definitiva por conducta': {
                'color': 'gray'
            },
            'Baja temporal voluntaria': {
                'color': 'gray'
            },
            'Suspensión por morosidad': {
                'color': 'red'
            },
            'Bloqueo para inscripción': {
                'color': 'red'
            },
            'Reactivación': {
                'color': 'blue'
            },
        },
        activeEditar: false,
        selectRow: []
    }),
    methods:{
        getRefresh(){
            this.$emit('refreshTable')
        }
    },
    components: {
        editar
    }
}
</script>

        